import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
// import moment from "moment";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import Checkbox from "../../../component/atoms/input/checkbox";
import PretendardText from "./../../../component/atoms/text/pretendardText";

import GoBack from "../../../component/molecules/goBack";

import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import GroupManagePopup from "../../../component/templates/user/userInfo/groupManagePopup";
import MemberApi from "../../../api/member.api";
import { errorHandler } from "../../../util/errorHandler";
import ListTopButtonGroup from "../../../component/templates/user/userInfo/listTopButtonGroup";
import GroupApi from "../../../api/group.api";
import { cMembershipList } from "../../../constants/userInfoConstants";
import moment from "moment";
import { formatNumberWithCommas } from "../../../util/formatNumber";
import CategoryApi from "../../../api/category.api";
import { route } from "../../../router/route";
import styled from "styled-components";
import { toast } from "react-toastify";
import ReviewList from "./_components/reviewList";
import AskList from "./_components/askList";
import BuyList from "./_components/buyList";
import MerchList from "./_components/merchList";

const UserInfoDetail = () => {
  let { id } = useParams();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_info)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [selectedGroupValue, setSelectedGroupValue] = useState();
  const [normalGroupList, setNormalGroupList] = useState([]);

  const [groupPopupOpen, setGroupPopupOpen] = useState(false);
  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  const [userInfo, setUserInfo] = useState();
  const [categoryList, setCategoryList] = useState([]);

  const [writableList, setWritableList] = useState([
    { title: "커뮤니티 공지사항", value: 3 },
    { title: "커뮤니티 알림&이벤트", value: 14 },
    { title: "커뮤니티 신규멤버 필독", value: 15 },
    { title: "커뮤니티 명예의 전당", value: 6 },
    { title: "커뮤니티 글쓰기 고수 칼럼", value: 7 },
    { title: "크루전용 자료창고", value: -1 },
  ]);

  useEffect(() => {
    getNormalGroupList();

    getUserInfoFunc();
    getMainCategoryList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selectedGroupValue) {
      setGroupPopupOpen(true);
    }
  }, [selectedGroupValue]);

  const getUserInfoFunc = async () => {
    try {
      const response = (await MemberApi.getDetail(id)).data.data.content;

      setUserInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 일반 그룹 가져오기
  const getNormalGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        memberGroupType: "NORMAL",
      };

      const response = (await GroupApi.getList(data)).data.data.content;
      setNormalGroupList(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  //  상품 카테고리 가져오기
  const getMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };
      const response = (await CategoryApi.getListMain(data)).data.data.content;

      let temp = response.map((item) => {
        return {
          value: item.id,
          title: item.title,
        };
      });

      setCategoryList(temp);
    } catch (error) {
      errorHandler(error);
    }
  };

  //열람 권한 가져오기
  const openMerchDetail = (data) => {
    if (!data.openMerchTitleList) {
      return;
    }

    if (
      data.openAllFlag === false &&
      data.openCategoryIdList.length === 0 &&
      data.openMerchIdList.length === 0
    ) {
      return "없음";
    }

    if (data.openAllFlag === true) {
      return "모든 상품";
    }

    if (data.openCategoryIdList.length > 0) {
      const filteredData = categoryList.filter((item) =>
        data.openCategoryIdList.includes(item.value)
      );
      let title = filteredData.map((item, index) => {
        if (filteredData.length === index + 1) {
          return `${item.title}`;
        } else {
          return `${item.title}, `;
        }
      });

      return title;
    }

    if (data.openMerchIdList.length > 0) {
      let title = data.openMerchTitleList.map((item, index) => {
        if (data.openMerchTitleList.length === index + 1) {
          return `${item}`;
        } else {
          return `${item}, `;
        }
      });

      return title;
    }
  };

  const joinTypeFunc = () => {
    const flags = [
      userInfo?.normalJoinFlag ? "일반" : "",
      userInfo?.kakaoFlag ? "카카오" : "",
      userInfo?.naverFlag ? "네이버" : "",
    ];

    // 빈 문자열을 제거하고 합침
    const result = flags.filter((flag) => flag).join(" / ");

    return result;
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />

            {isWriteAuthority && (
              <ListTopButtonGroup
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: 12,
                }}
                setButtonGroupOpen={() => {}}
                setAlarmPopupOpen={setAlarmPopupOpen}
                setSMSPopupOpen={setSMSPopupOpen}
                getMemberList={getUserInfoFunc}
                normalGroupList={normalGroupList}
                setSelectedGroupValue={setSelectedGroupValue}
                userCheckedIdList={[userInfo]}
                sessionStorageInit={() => {}}
                selectedGroupId={0}
                initRoute={() => {}}
              />
            )}
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 30,
              }}
            >
              <DetailPageTitle
                style={{
                  marginBottom: 12,
                }}
              >
                회원 상세 내역
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* 이름 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    이름
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.name}</DetailFormText>
                </DetailPageForm>
                {/* 아이디(이메일) */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    아이디(이메일)
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.email}</DetailFormText>
                </DetailPageForm>
                {/* 닉네임 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    닉네임
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.nickname}</DetailFormText>
                </DetailPageForm>
                {/* 회원등급/레벨 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    회원등급/레벨
                  </DetailFormTitle>
                  <DetailFormText>
                    {cMembershipList[userInfo?.membership]}/Lv.
                    {userInfo?.writingLevel}
                  </DetailFormText>
                </DetailPageForm>
                {/* 누적구매 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    누적구매
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.purchaseCount}회/
                    {formatNumberWithCommas(userInfo?.purchaseAmount)}원
                  </DetailFormText>
                </DetailPageForm>
                {/* 보유포인트 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    보유포인트
                  </DetailFormTitle>
                  <DetailFormText>
                    {Number(userInfo?.totalPoint).toLocaleString()}P
                  </DetailFormText>
                </DetailPageForm>
                {/* 가입연동 아이디 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    가입연동 아이디
                  </DetailFormTitle>
                  <DetailFormText>{joinTypeFunc()}</DetailFormText>
                </DetailPageForm>
                {/* 핸드폰 번호 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    핸드폰 번호
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.phoneNumber.replace(
                      /(\d{3})(\d{4})(\d{4})/,
                      "$1-$2-$3"
                    )}
                  </DetailFormText>
                </DetailPageForm>
                {/* 그룹 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    그룹
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.groupList && userInfo?.groupList?.length > 0
                      ? userInfo.groupList.map((group, index02) => {
                          return (
                            <span key={index02}>
                              {group.title}
                              {index02 !== userInfo.groupList.length - 1 &&
                                ", "}
                            </span>
                          );
                        })
                      : "그룹 없음"}
                  </DetailFormText>
                </DetailPageForm>
                {/* 열람 권한 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    열람 권한
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo ? openMerchDetail(userInfo) : ""}
                  </DetailFormText>
                </DetailPageForm>
                {/* 글쓰기 권한 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    글쓰기 권한
                  </DetailFormTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {userInfo?.writableCategoryIdList?.length > 0 ? (
                      userInfo?.writableCategoryIdList?.map((item, index) => {
                        return (
                          <PretendardText
                            key={index}
                            style={{
                              fontWeight: 400,
                              fontSize: 14,
                              lineHeight: "19.6px",
                              color: "#aaa",
                              marginRight: 6,
                            }}
                          >
                            {
                              writableList.find(
                                (item02) => item02.value === item
                              )?.title
                            }
                            {userInfo?.writableCategoryIdList?.length ===
                            index + 1
                              ? ""
                              : ","}
                          </PretendardText>
                        );
                      })
                    ) : (
                      <DetailFormText>없음</DetailFormText>
                    )}
                  </div>
                </DetailPageForm>
                {/* 가입일 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    가입일
                  </DetailFormTitle>
                  <DetailFormText>
                    {moment(userInfo?.createdAt).format("YYYY-MM-DD")}
                  </DetailFormText>
                </DetailPageForm>
                {/* 마지막 접속 날짜 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    마지막 접속 날짜
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.lastLoginDate
                      ? moment(userInfo?.lastLoginDate).format("YYYY-MM-DD")
                      : ""}
                  </DetailFormText>
                </DetailPageForm>
                {/* 약관 동의 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                    border: "none",
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    약관 동의
                  </DetailFormTitle>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Checkbox
                      checked={userInfo?.receiveAgreement}
                      onChange={() => {}}
                    />
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 14,
                        lineHeight: "21px",
                        color: "#999",
                      }}
                    >
                      혜택 및 이벤트 등 서비스 알림 수신에 동의합니다(선택)
                    </PretendardText>
                  </div>
                </DetailPageForm>
              </div>
            </div>
            <div
              style={{
                marginBottom: "33px",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                gap: 16,
              }}
            >
              <ReviewList />  
              <AskList />            
            </div>
            <div
              style={{
                marginBottom: "28px",
              }}
            >
              <BuyList />   
            </div>
            <div>
              <MerchList />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {/* 그룹 정보 수정 팝업 */}
      {groupPopupOpen && (
        <GroupManagePopup
          setPopupOpen={setGroupPopupOpen}
          selectedGroupValue={selectedGroupValue}
          getNormalGroupList={getNormalGroupList}
          getOperateGroupList={() => {}}
        />
      )}

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={[userInfo]}
          getMemberList={getUserInfoFunc}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={[userInfo]}
          getMemberList={getUserInfoFunc}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}
    </>
  );
};

export default UserInfoDetail;


